<template>
  <q-avatar
    class="on-left"
    :icon="tabOutlineUser"
    :style="`background-color: ${stringToHslColor(uid, 50, 70)}`"
    :text-color="'white'"
  />
</template>

<script setup>
import { tabOutlineUser } from 'quasar-extras-svg-icons/tabler-icons-v3';

defineProps({
  uid: {
    type: String,
    required: true,
  },
});

function stringToHslColor(str, s, l) {
  if (!str) return 'hsl(78, 0%, 47%)';

  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  var h = hash % 360;
  return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
}
</script>
